import { Link, useTheme } from '@material-ui/core';
import { FC } from 'react';

import { WithStyles, withStyles } from '@core/theme/utils/with-styles';
import { AtlasLogoIcon } from '@shared/icons/atlas-logo';

import { styles } from './AtlasNavigationLogo.styles';

export interface AtlasNavigationLogoProps extends WithStyles<typeof styles> {
  url: string;
}

const AtlasNavigationLogoComponent: FC<AtlasNavigationLogoProps> = ({ classes, url }) => {
  const theme = useTheme();

  return (
    <Link classes={{ root: classes.root }} href={url}>
      <AtlasLogoIcon classes={{ root: classes.logo }} color={theme.palette.primarySpecial.main} />
    </Link>
  );
};

export const AtlasNavigationLogo = withStyles(styles)(AtlasNavigationLogoComponent);
